import { API_BASE_URL, API_STORE_EXAM_RESULT_PATH } from '../../consts';
import axios from "axios";
import refreshAccessToken from './refreshAccessToken';


interface getStoreExamResultResponse {
    store_exam_status: string;
}

async function executeGetStoreExamResultWithToken(accessToken: string | null, uuid: string, each_result: { [key: string]: boolean[] }): Promise<getStoreExamResultResponse> {
    return axios
        .post(
            API_BASE_URL + API_STORE_EXAM_RESULT_PATH,
            {
                uuid: uuid,
                each_result: each_result
            },
            {
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
                withCredentials: true,
            }
        )
        .then(response => {
            if (response.status === 201) {
                return Promise.resolve(response.data);
            }
        })
        .catch(error => {
            if (error.response && error.response.status === 401) {
                console.log("not authenticated");
            } else {
                console.error('Error during creation:', error);
            }
            return Promise.reject(error);
        });
}


export default async function autoRefreshedExecuteGetStoreExamResultWithToken(accessToken: string | null, uuid: string, each_result: { [key: string]: boolean[] }): Promise<getStoreExamResultResponse> {

    return executeGetStoreExamResultWithToken(accessToken, uuid, each_result)
        .catch(error => {
            if (error.response.status == 401) {
                return refreshAccessToken().then(refreshedAccessToken => {
                    if (refreshedAccessToken) {
                        console.log("refreshed");
                        return executeGetStoreExamResultWithToken(accessToken, uuid, each_result);
                    } else {
                        throw error;
                    }
                });
            }
            throw error;
        });
}
